import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { EnvironmentService } from '../environment-service/environment.service';
import { SessionManagementService } from '../session-management-service/session-management.service';

import * as Jquery from 'jquery';
import * as c3 from 'c3';
import * as d3 from 'd3';

@Injectable()
export class ChartGeneratorService {

  private pipe = new DatePipe('en-US');
  private _applicationIdRoots: string[] = [];

  constructor(private environmentService: EnvironmentService, private sessionManagementService: SessionManagementService) {
    this._applicationIdRoots = [
      'approvaltool',
      'connex',
      'connex.accounting.taskrunner',
      'connex.accounting',
      'connex.agencyBalance',
      'connex.operations',
      'connex.payments',
      'connex.permissions',
      'connex.reporting',
      'encirca',
      'mitt',
      'salestasks'
    ];
  }

  get applicationIdRoots() {
    return this._applicationIdRoots;
  }

  formatAMPM(date: number | Date): string {
    return this.pipe.transform(date, 'hh:mm aa');
  }

  FormatDate(date: Date): string {
    const allButMinutes = this.pipe.transform(date, 'MM/dd/yyyy HH'); // HH because we want military time!
    const minutes = String(Math.floor(date.getMinutes() / 5) * 5).padStart(2, '0');

    return `${allButMinutes}:${minutes}`;
  }

  createTwoYAxisChart(data, elementSelector: string, chartName: string) {
    var mythis = this;
    if ($(elementSelector).html().length == 0) {
      $(elementSelector).html("Loading " + chartName + " chart...");
    }
    c3.generate({
      bindto: elementSelector,
      size: {
        height: 200
      },
      data: {
        json: data,
        keys: {
          x: 'occurredOn',
          value: ['errors', 'calls'],
        },
        xFormat: '%m/%d/%Y %H:%M:%S',
        type: 'area-spline',
        axes: {
          errors: 'y2',
          calls: 'y'
        },
      },
      color: { pattern: ['#ff6666', '#99cc00'] },
      grid: {
        y: { show: true }
      },
      axis: {
        y: {
          min: 0,
          padding: { top: 5, bottom: 0 },
          label: chartName,
          tick: {
            format: d3.format("d")
          }
        },
        y2: {
          show: true,
          min: 0,
          padding: { top: 5, bottom: 0 },
          label: 'Errors',
          tick: {
            format: d3.format("d")
          }
        },
        x: {
          type: 'timeseries',
          tick: {
            fit: false,
            format: function (d) {
              return mythis.formatAMPM(d);
            }
          }
        }
      },
      tooltip: {
        format: {
          title: function (d) {
            return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
          },
          value: function (value, ratio, id) {
            var format = d3.format(',');
            return format(value);
          }
        }
      }
    });
  }

  createChart(data, elementSelector, color, chartName) {
    var mythis = this;
    if ($(elementSelector).html().length == 0) {
      $(elementSelector).html("Loading " + chartName + " chart...");
    };
    let chartData = {
      bindto: elementSelector,
      size: {
        height: 200
      },
      data: {
        json: data,
        keys: {
          x: 'occurredOn',
          value: ['instances'],
        },
        xFormat: '%m/%d/%Y %H:%M:%S',
        type: 'area-spline',
        axes: {
          instances: 'y2'
        },
      },
      color: { pattern: [color] },
      grid: {
        y: { show: true }
      },
      axis: {
        y: {
          show: false,
          min: 0,
          padding: { top: 5, bottom: 0 },
          label: chartName
        },
        y2: {
          show: true,
          min: 0,
          padding: { top: 5, bottom: 0 },
          label: chartName,
          tick: {
            format: d3.format("d")
          }
        },
        x: {
          type: 'timeseries',
          tick: {
            fit: false,
            format: function (d) {
              return mythis.formatAMPM(d);
            }
          }
        }
      },
      tooltip: {
        format: {
          title: function (d) {
            return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
          },
          value: function (value, ratio, id) {
            var format = d3.format(',');
            return format(value);
          }
        }
      }
    };
    console.log(chartData);
    
    c3.generate(chartData);
  };

  GetAggregatedData(startDate: Date, endDate: Date, interval: number, applicationIds: string[]) {
    var mythis = this;
    var url = this.environmentService.getApiRoot() + "aggregated/activity";
    console.log('Getting chart data.');
    $.ajax({
      contentType: 'application/json',
      url: url,
      type: 'POST',
      headers: {
        'telemetry-session': this.sessionManagementService.getSession(),
        'telemetry-request': this.sessionManagementService.uuidFast()
      },
      data: JSON.stringify({
        "startTime": mythis.FormatDate(startDate),
        "endTime": mythis.FormatDate(endDate),
        "interval": interval,
        "applicationIds": applicationIds
      }),
      success: function (data) {
        var browser = [];
        var web = [];
        var database = [];
        var users = [];

        for (var i = 0; i < data.length; i++) {
          browser.push({ occurredOn: data[i]['occurredOn'], errors: data[i]['browserErrors'], calls: data[i]['browserCalls'] });
          web.push({ occurredOn: data[i]['occurredOn'], errors: data[i]['webServiceErrors'], calls: data[i]['webServiceCalls'] });
          database.push({ occurredOn: data[i]['occurredOn'], errors: data[i]['databaseErrors'], calls: data[i]['databaseCalls'] });
          users.push({ occurredOn: data[i]['occurredOn'], instances: data[i]['activeUsers'] });
        }

        mythis.createChart(
          users,
          '#activeUserChart',
          '#99cc00',
          'users');

        mythis.createTwoYAxisChart(
          database,
          '#databaseChart',
          'database');

        mythis.createTwoYAxisChart(
          web,
          '#webChart',
          'web service');

        mythis.createTwoYAxisChart(
          browser,
          '#browserChart',
          'browser');

      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      },
      complete: function () {
      }
    });
  }


}
